/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: f8fa3dab0b79
 */

import * as z from "zod";

export type Transformations = { usage?: number | undefined };

export const Transformations$zodSchema: z.ZodType<Transformations> = z.object({
  usage: z.int().optional().describe("Number of transformations used"),
});

export type Objects = {
  usage?: number | undefined;
  limit?: number | undefined;
  used_percent?: number | undefined;
};

export const Objects$zodSchema: z.ZodType<Objects> = z.object({
  limit: z.int().optional().describe("Object limit for the plan"),
  usage: z.int().optional().describe("Number of objects used"),
  used_percent: z.number().optional().describe(
    "Percentage of object limit used",
  ),
});

export type Bandwidth = {
  usage?: number | undefined;
  limit?: number | undefined;
  used_percent?: number | undefined;
};

export const Bandwidth$zodSchema: z.ZodType<Bandwidth> = z.object({
  limit: z.int().optional().describe("Bandwidth limit for the plan"),
  usage: z.int().optional().describe("Bandwidth used in bytes"),
  used_percent: z.number().optional().describe(
    "Percentage of bandwidth limit used",
  ),
});

export type Storage = {
  usage?: number | undefined;
  limit?: number | undefined;
  used_percent?: number | undefined;
};

export const Storage$zodSchema: z.ZodType<Storage> = z.object({
  limit: z.int().optional().describe("Storage limit for the plan"),
  usage: z.int().optional().describe("Storage used in bytes"),
  used_percent: z.number().optional().describe(
    "Percentage of storage limit used",
  ),
});

export type Impressions = { usage?: number | undefined };

export const Impressions$zodSchema: z.ZodType<Impressions> = z.object({
  usage: z.int().optional().describe("Number of impressions used"),
});

export type SecondsDelivered = { usage?: number | undefined };

export const SecondsDelivered$zodSchema: z.ZodType<SecondsDelivered> = z.object(
  {
    usage: z.int().optional().describe("Number of seconds delivered"),
  },
);

/**
 * Upload size and pixel limits
 */
export type MediaLimits = {
  image_max_size_bytes?: number | undefined;
  video_max_size_bytes?: number | undefined;
  raw_max_size_bytes?: number | undefined;
  image_max_px?: number | undefined;
  asset_max_total_px?: number | undefined;
};

export const MediaLimits$zodSchema: z.ZodType<MediaLimits> = z.object({
  asset_max_total_px: z.int().optional().describe(
    "Maximum total pixels for assets",
  ),
  image_max_px: z.int().optional().describe("Maximum pixels for images"),
  image_max_size_bytes: z.int().optional().describe(
    "Maximum size for images in bytes",
  ),
  raw_max_size_bytes: z.int().optional().describe(
    "Maximum size for raw files in bytes",
  ),
  video_max_size_bytes: z.int().optional().describe(
    "Maximum size for videos in bytes",
  ),
}).describe("Upload size and pixel limits");

export type UsageResponse = {
  plan?: string | undefined;
  last_updated?: string | undefined;
  date_requested?: string | undefined;
  transformations?: Transformations | undefined;
  objects?: Objects | undefined;
  bandwidth?: Bandwidth | undefined;
  storage?: Storage | undefined;
  impressions?: Impressions | undefined;
  seconds_delivered?: SecondsDelivered | undefined;
  resources?: number | undefined;
  derived_resources?: number | undefined;
  requests?: number | undefined;
  media_limits?: MediaLimits | undefined;
};

export const UsageResponse$zodSchema: z.ZodType<UsageResponse> = z.object({
  bandwidth: z.lazy(() => Bandwidth$zodSchema).optional(),
  date_requested: z.iso.datetime({ offset: true }).optional().describe(
    "The date for which usage was requested",
  ),
  derived_resources: z.int().optional().describe("Number of derived resources"),
  impressions: z.lazy(() => Impressions$zodSchema).optional(),
  last_updated: z.string().date().optional().describe(
    "When the usage data was last updated",
  ),
  media_limits: z.lazy(() => MediaLimits$zodSchema).optional().describe(
    "Upload size and pixel limits",
  ),
  objects: z.lazy(() => Objects$zodSchema).optional(),
  plan: z.string().optional().describe("The current plan name"),
  requests: z.int().optional().describe("Number of requests made"),
  resources: z.int().optional().describe("Number of resources stored"),
  seconds_delivered: z.lazy(() => SecondsDelivered$zodSchema).optional(),
  storage: z.lazy(() => Storage$zodSchema).optional(),
  transformations: z.lazy(() => Transformations$zodSchema).optional(),
});
